import React from 'react';
import { CandidateJobTitlesViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: CandidateJobTitlesViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
